export const equipmentListPageSize = 20;
export const equipmentListWebflowOffset = 20;
export const equipmentSearchResultPageSize = 5;
